__turbopack_context__.v({
  "button": "ctaButton-module-scss-module__PBPm9a__button",
  "link": "ctaButton-module-scss-module__PBPm9a__link",
  "primary": "ctaButton-module-scss-module__PBPm9a__primary",
  "primaryWhite": "ctaButton-module-scss-module__PBPm9a__primaryWhite",
  "secondary": "ctaButton-module-scss-module__PBPm9a__secondary",
  "secondaryDark": "ctaButton-module-scss-module__PBPm9a__secondaryDark",
  "secondaryGradient": "ctaButton-module-scss-module__PBPm9a__secondaryGradient",
  "secondaryWhite": "ctaButton-module-scss-module__PBPm9a__secondaryWhite",
});
